var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canBeSummarized)?_c('button',{directives:[{name:"tippy",rawName:"v-tippy"}],attrs:{"title":"Log activity"},on:{"click":_vm.summarize}},[_c('crm-logo')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7038020b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CallInfo/SummarizeButton.vue
// module id = e533
// module chunks = 1